<template>
    <li v-bind:class="{ active: server.selected }"><div v-on:click="toggleShow" class="color" v-bind:style="{backgroundColor: '#ffd093'}"><span v-show="server.show">✔</span></div> <a v-on:click="toggleSelected" href="#">{{alpha_replace[server.name] + ': ' + server.name}}({{server.count}})</a></li>
</template>

<script>
    export default {
        name: "ServerItem",
        data: function (){
            return {
                alpha_replace: greck
            }
        },
        props:{
            server: Object
        },
        methods:{
            toggleSelected: function (){

            },
            toggleShow: function (){

            }
        }
    }
</script>

<style scoped>
    .color span{
        padding: 0;
        margin: 0;
    }

    .color{
        display: inline-block;
        border: 1px solid #ffffff;
        width: 1rem;
        height: 1rem;
        background-color: #EEEEEE;
        margin-right: 0.2rem;
        box-shadow: 1px 1px 0px #425360;
        font-size: 0.7rem;
        color: #ffffff;
        text-align: center;
        cursor: default;
    }

    li{
        display: flex;
    }
</style>
